import {gql} from '@apollo/client';

export const UPDATE_USER_KYC_STATUS = gql`
  mutation UpdateKycStatus(
    $userId: ID!
    $kycStatus: InvestorKycStatus!
    $amlStatus: InvestorKycStatus
    $documentCheckStatus: InvestorKycStatus
    $rejectionCode: String
    $rejectionMessages: JSON
    $iskycreset: Boolean
  ) {
    updateKycStatus(
      userId: $userId
      kycStatus: $kycStatus
      amlStatus: $amlStatus
      documentCheckStatus: $documentCheckStatus
      rejectionCode: $rejectionCode
      rejectionMessages: $rejectionMessages
      # Spelled exactly as the schema has it. Optional, defaults to false, and
      # an ordinary status update leaves it out entirely — passing it as true
      # forces all three checks back to NOT_STARTED and fires KYC_RESET.
      iskycreset: $iskycreset
    ) {
      ... on Error {
        message
        statusCode
      }
      ... on IdentityCard {
        id
        kycStatus
        amlStatus
        documentCheckStatus
      }
    }
  }
`;

export const GENERATE_USER_REFERRAL_CODE = gql`
  mutation AdminGenerateReferralCode($data: UserCustomReferralInput!) {
    adminGenerateReferralCode(data: $data) {
      ... on Error {
        message
        statusCode
      }
      ... on Response {
        message
      }
    }
  }
`;

export const CREATE_USER_INTERACTION = gql`
  mutation AddInteraction($input: InteractionInput!) {
    addInteraction(input: $input) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithInteraction {
        message
      }
    }
  }
`;

export const DELETE_USER_INTERACTION = gql`
  mutation DeleteInteractionById($deleteInteractionByIdId: ID!) {
    deleteInteractionById(id: $deleteInteractionByIdId) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithInteraction {
        message
      }
    }
  }
`;

export const UPDATE_USER_INTERACTION = gql`
  mutation UpdateInteraction(
    $updateInteractionId: ID!
    $input: InteractionInput!
  ) {
    updateInteraction(id: $updateInteractionId, input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithInteraction {
        message
      }
    }
  }
`;

export const UPDATE_ADMIN_PROFILE = gql`
  mutation UpdateAdminProfile($data: UpdateUserProfileInput!) {
    updateAdminProfile(data: $data) {
      ... on UserType {
        user {
          firstName
          lastName
          email
        }
      }
      ... on Error {
        statusCode
        message
      }
    }
  }
`;

// Hand a manual (user-uploaded) submission to Smile ID so the reviewer does not
// have to re-key it into the Smile portal. The card stays in the review queue:
// Smile's answer is advice, and only a `clear` approves on its own.
export const SEND_MANUAL_KYC_TO_SMILE_ID = gql`
  mutation SendManualKycToSmileId($userId: ID!) {
    sendManualKycToSmileId(userId: $userId) {
      ... on Error {
        message
        statusCode
      }
      ... on IdentityCard {
        id
        kycStatus
        smileSubmission {
          status
          jobId
          attempts
          lastError
          submittedAt
          triggeredBy
        }
      }
    }
  }
`;

export const PERFORM_MANUAL_SIM_ID_CHECK = gql`
  mutation PerformManualSmileIDCheck($input: ManualSmileIDKYCInput!) {
    performManualSmileIDCheck(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on IdentityCard {
        amlStatus
      }
    }
  }
`;

export const REMOVE_USER_FROM_OTP_BLACKLIST = gql`
  mutation RemoveUserFromOtpBlacklist(
    $input: RemoveUserFromOTPBlackListInput!
  ) {
    removeUserFromOtpBlacklist(input: $input) {
      __typename
      ... on ResponseWithOtpBlacklistRemoval {
        message
        data {
          userId
          mongoRemovedCount
          redisKeysRemoved
        }
      }
      ... on Error {
        message
        statusCode
      }
    }
  }
`;

export const SEND_KYC_NOTIFICATION = gql`
  mutation SendKycNotification($input: SendKycNotificationInput!) {
    sendKycNotificationToUser(input: $input) {
      __typename
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithKycNotificationDispatch {
        message
        userId
        reason
        language
        channels {
          channel
          notificationId
          status
          reason
        }
      }
    }
  }
`;
